<template>
    <div id="pwa-intervention-device-report" class="mx-2">
        <button-go-back text="Liste des dispositifs"></button-go-back>

        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div class="intervention-details__card">
                    <p class="font-medium text-base">{{ textHeader }}</p>
                    <span class="text-sm leading-none"><span class="font-medium text-primary">Localisation</span> : {{ device.location }}</span>
                    <md-divider class="mb-1 mt-1.5 -mx-2"></md-divider>
                    <div class="px-1">
                        <report-model1 v-if="reportType.report.id === 1" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model1>
                        <report-model2 v-if="reportType.report.id === 2" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model2>
                        <report-model3 v-if="reportType.report.id === 3" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model3>
                        <report-model4 v-if="reportType.report.id === 4" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model4>
                        <report-model5 v-if="reportType.report.id === 5" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model5>
                        <report-model6 v-if="reportType.report.id === 6" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model6>
                        <report-model7 v-if="reportType.report.id === 7" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model7>
                        <report-model8 v-if="reportType.report.id === 8" :reportType="reportType.report" :reportConfig="reportType.config" :device="device"></report-model8>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import ButtonGoBack from "@/pages/ProgressiveWebApp/components/ButtonGoBack";

import ReportModel1 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel1";
import ReportModel2 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel2";
import ReportModel3 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel3";
import ReportModel4 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel4";
import ReportModel5 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel5";
import ReportModel6 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel6";
import ReportModel7 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel7";
import ReportModel8 from "@/pages/ProgressiveWebApp/Planning/devices/components/ReportModel8";

import indexedDBMixin from "@/mixins/indexed-db-mixin";

export default {
    name: "PwaInterventionDeviceReport",
    components: { ButtonGoBack, ReportModel1, ReportModel2, ReportModel3, ReportModel4,
        ReportModel5, ReportModel6, ReportModel7, ReportModel8 },
	mixins: [indexedDBMixin],
    data() {
        return {
            device: {
                id: '',
                number: '',
                deviceType: {}
            },
            reportType: {
                report: {
					id: ''
                },
	            config: {}
            },
	        isUnavailable: false
        }
    },
    computed: {
        textHeader() {
            return `Dispositif n°${this.device.number} (Fiche #${this.reportType.report.id})`
        }
    },
    methods: {
        async getDeviceReportDetails() {
	        const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	        const site = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/site`)
	        const device = site.value.devices.find(device => device.id === parseInt(this.$route.params.deviceId))

	        const deviceType = await this.fetchDataFromIndexedDB(`pwa/device_types/${device.device_type_id}`)
	        const deviceReportType = await this.fetchDataFromIndexedDB(`pwa/device_report_types/${deviceType.value.device_report_type_id}`)
	        const deviceIsSameInterventionType = !!deviceType.value.intervention_types.find(interventionType => interventionType.id === intervention.value.intervention_type_id)

	        const deviceTypes = []
	        deviceReportType.value.report.device_types.map(async deviceType => {
				const type = await this.fetchDataFromIndexedDB(`pwa/device_types/${deviceType.id}`)
				deviceTypes.push(type.value)
	        })
	        delete deviceReportType.value.report.device_types

	        this.device = {
				...device,
		        deviceType: deviceType.value,
		        isSameInterventionType: deviceIsSameInterventionType
			}
	        this.reportType = {
				report: {
					...deviceReportType.value.report,
					deviceTypes: deviceTypes
				},
		        config: deviceReportType.value.config
			}
        },
    },
    mounted() {
        this.getDeviceReportDetails()
    },
}
</script>

<style scoped>

</style>
